/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Smartlab_Settings_Password_Keep_HintInputs */

const vi_smartlab_settings_password_keep_hint = /** @type {(inputs: Smartlab_Settings_Password_Keep_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã có mật khẩu được lưu. Để trống ô này nếu bạn không muốn thay đổi.`)
};

/**

* @param {Smartlab_Settings_Password_Keep_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const smartlab_settings_password_keep_hint = /** @type {((inputs?: Smartlab_Settings_Password_Keep_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Smartlab_Settings_Password_Keep_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_smartlab_settings_password_keep_hint(inputs)
});